module.exports = __webpack_public_path__ + "../resources/images/more-d8014709ff80244c8fea9988a8b54616.svg";